import { render, staticRenderFns } from "./FruttoStatisticsItem.vue?vue&type=template&id=e288527a&scoped=true&"
import script from "./FruttoStatisticsItem.vue?vue&type=script&lang=js&"
export * from "./FruttoStatisticsItem.vue?vue&type=script&lang=js&"
import style0 from "./FruttoStatisticsItem.vue?vue&type=style&index=0&id=e288527a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e288527a",
  null
  
)

export default component.exports